import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { getEvents, IEventsResponseBody, IGetEventsParams } from 'src/api/getEvents';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { QueryKeys } from '../QueryKeys';

export const useEvents = (
  params?: IGetEventsParams,
  options?: UseQueryOptions<IEventsResponseBody>,
): UseQueryResult<IEventsResponseBody> => {
  const { showSnackbar } = useSnackbar();

  return useQuery<IEventsResponseBody>({
    queryKey: [QueryKeys.events, getBrandId(), params],
    queryFn: () => getEvents(params),
    refetchOnWindowFocus: false,
    onError: () => showSnackbar({ status: SnackbarStatus.ERROR, message: 'Internal Server Error' }),
    ...options,
  });
};
